// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BIBXb","subtitle":"styles_subtitle__AdjrB","content":"styles_content__3lBnS"};